var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{staticClass:"chart",attrs:{"chart-data":_vm.datacollection,"min-val":_vm.minVal,"max-val":_vm.maxVal}})}
var staticRenderFns = []

export { render, staticRenderFns }